import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import SubmitButton from '../../components/Interactables/Misc/SubmitButton';
import api from '../../config/api-config';
import './UserBoards.css';

const UserBoards = () => {
  const [boards, setBoards] = useState([]);
  const [newBoardName, setNewBoardName] = useState('');
  const [loading, setLoading] = useState(false);
  const [boardsLoading, setBoardsLoading] = useState(true);
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      fetchBoards();
    }
  }, [user]);

  const fetchBoards = async () => {
    try {
      setBoardsLoading(true);
      const token = await user.getIdToken();
      const response = await api.get(`/api/user/boards?userId=${user.uid}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        }
      });
      console.log("Fetched boards:", response.data); // Debugging
      setBoards(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error('Error fetching boards:', error);
    } finally {
      setBoardsLoading(false);
    }
  };

  const handleCreateBoard = async (e) => {
    e.preventDefault();
    if (!newBoardName.trim()) return;
    
    setLoading(true);
    try {
      const token = await user.getIdToken();
      const response = await api.post('/api/boards', 
        { name: newBoardName },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          }
        }
      );
      setBoards([...boards, response.data]);
      setNewBoardName('');
      fetchBoards(); // Refresh the boards list
    } catch (error) {
      console.error('Error creating board:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleBoardClick = (boardId) => {
    navigate(`/board/${boardId}`);
  };

  return (
    <div className="user-boards-container">
      <div className="user-boards-header">
        <h1>Your Boards</h1>
      </div>
      
      {boardsLoading ? (
        <div className="boards-loading">
          <div className="boards-loading-spinner"></div>
          <p>Loading your boards...</p>
        </div>
      ) : boards.length > 0 ? (
        <div className="boards-list">
          {boards.map((board) => (
            <div 
              key={board.id} 
              className="board-card"
              onClick={() => handleBoardClick(board.id)}
            >
              <h3>{board.name}</h3>
              <p>Created: {new Date(board.createdAt).toLocaleDateString()}</p>
            </div>
          ))}
        </div>
      ) : (
        <div className="no-boards-message">
          <p>You don't have any boards yet. Create your first board below!</p>
        </div>
      )}
      
      <div className="create-board-form">
        <h2>Create New Board</h2>
        <form onSubmit={handleCreateBoard}>
          <div className="form-group">
            <label htmlFor="boardName">Board Name</label>
            <input
              id="boardName"
              type="text"
              placeholder="Enter board name"
              value={newBoardName}
              onChange={(e) => setNewBoardName(e.target.value)}
            />
          </div>
          <div className="form-actions">
            <SubmitButton loading={loading}>Create Board</SubmitButton>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserBoards;
